import { render, staticRenderFns } from "./propertyMaintenanceList.vue?vue&type=template&id=33e24998&scoped=true&"
import script from "./propertyMaintenanceList.vue?vue&type=script&lang=js&"
export * from "./propertyMaintenanceList.vue?vue&type=script&lang=js&"
import style0 from "./propertyMaintenanceList.vue?vue&type=style&index=0&id=33e24998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e24998",
  null
  
)

export default component.exports